<template lang="pug">
  div
    v-row(no-gutters align="center")
      v-col(cols="4")
        v-text-field.p1(v-model="settings.preparation_time_value" outlined dense background-color="basic200" placeholder="0" hide-details type="number" :rules="checkUnit()")
      v-col(cols="6")
        v-select.mx-3.p1(v-model="settings.preparation_time_unit" outlined dense background-color="basic200" placeholder="minutes" hide-details :items="preparationTimeUnits" item-text="name" item-value="value")
          template(v-slot:append)
            eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
</template>

<script>
export default {
  name: 'PreparationTime',
  components: { },
  props: ['parentSettings'],
  data: () => ({
    preparationTimeUnits: [
      { name: 'Minutes', value: 'minutes' },
      { name: 'Hours', value: 'hours' },
      { name: 'Days', value: 'days' }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
    }
  }),
  computed: {
    settings: {
      get () {
        return this.parentSettings
      },
      set (newValue) {
        this.$emit('update:parentSettings', newValue)
      }
    },
  },
  watch: {

  },
  mounted () {

  },
  methods: {
    checkUnit () {
      if (this.settings.preparation_time_unit === 'minutes') {
        return [(v) => !!v || 'This field is required', (v) => v != 0 || 'This field is required', (v) => v < 1440 || 'Exceed maximum value allowed']
      } else if (this.settings.preparation_time_unit === 'hours') {
        return [(v) => !!v || 'This field is required', (v) => v != 0 || 'This field is required', (v) => v < 24 || 'Exceed maximum value allowed']
      } else {
        return [(v) => !!v || 'This field is required', (v) => v != 0 || 'This field is required']
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>
